// Alergias (Sí/No + especificar), grupo sanguíneo y factor Rh de la cabecera de 113/114/115. Lógica en `datosClinicosUci.ts`.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { SiNoBotones } from '../camposSimples';
import { FACTORES_RH, GRUPOS_SANGUINEOS, type EstadoAlergiasSangre } from './datosClinicosUci';

function Opciones<V extends string>({ etiqueta, opciones, valor, textoDe, onChange }: { readonly etiqueta: string; readonly opciones: readonly V[]; readonly valor: V | ''; readonly textoDe: (v: V) => string; readonly onChange: (v: V | '') => void }): JSX.Element {
  return (
    <fieldset className="flex min-w-0 flex-col gap-1 border-0 p-0">
      <legend className="p-0 text-sm font-medium">{etiqueta}</legend>
      <div className="flex flex-wrap gap-2">
        {opciones.map((o) => (
          <Button key={o} type="button" size="sm" variant={valor === o ? 'default' : 'outline'} aria-pressed={valor === o} onClick={() => onChange(valor === o ? '' : o)}>
            {textoDe(o)}
          </Button>
        ))}
      </div>
    </fieldset>
  );
}

export function CamposClinicosUci({ prefijoId, estado, onChange }: { readonly prefijoId: string; readonly estado: EstadoAlergiasSangre; readonly onChange: (v: EstadoAlergiasSangre) => void }): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-col gap-2">
        <SiNoBotones id={`${prefijoId}-alergias-sino`} etiqueta={t('formularios.uci.datosClinicos.alergiasSiNo')} valor={estado.alergiasSiNo} onChange={(v) => onChange({ ...estado, alergiasSiNo: v })} />
        {estado.alergiasSiNo === 'no' ? null : (
          <div className="flex flex-col gap-1">
            <Label htmlFor={`${prefijoId}-alergias`}>{t('formularios.uci.datosClinicos.alergiasEspecificar')}</Label>
            <Input id={`${prefijoId}-alergias`} value={estado.alergias} onChange={(e) => onChange({ ...estado, alergias: e.target.value })} />
          </div>
        )}
      </div>
      <Opciones etiqueta={t('formularios.uci.datosClinicos.grupoSanguineo')} opciones={GRUPOS_SANGUINEOS} valor={estado.grupoSanguineo} textoDe={(v) => v} onChange={(v) => onChange({ ...estado, grupoSanguineo: v })} />
      <Opciones
        etiqueta={t('formularios.uci.datosClinicos.factorRh')}
        opciones={FACTORES_RH}
        valor={estado.factorRh}
        textoDe={(v) => t(v === 'positivo' ? 'formularios.uci.datosClinicos.rhPositivo' : 'formularios.uci.datosClinicos.rhNegativo')}
        onChange={(v) => onChange({ ...estado, factorRh: v })}
      />
    </>
  );
}
